module.exports = __webpack_public_path__ + "static/img/irregular_skin-01.fe34944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/irregular_skin-01.jpg
// module id = 271
// module chunks = 1